module.exports = __webpack_public_path__ + "img/BVT.d7b21049.svg";